module.exports = __webpack_public_path__ + "c3705030b2d1f4e270eb810d44a65bdd.pdf";